module.exports = __webpack_public_path__ + "static/media/brego3593.a897b399.jpg";